<template>
    <div>
      <h2>Bank Transactions</h2>
      <div v-for="transaction in open_transactions" :key="transaction.id">
        {{ transaction }}
        <customer-dropdown :transaction-id="transaction.id" :customers="customers" />
        <gutschrift-creation :transaction-id="transaction.id" />
        <ignore-transaction :transaction-id="transaction.id" />
      </div>
    </div>
  </template>
  
  <script>
  import CustomerDropdown from '../../Modules/Transactions/CustomerDropdown.vue';
  import GutschriftCreation from '../../Modules/Transactions/GutschriftCreation.vue';
  import IgnoreTransaction from '../../Modules/Transactions/IgnoreTransaction.vue';
  
  export default {
    components: {
      CustomerDropdown,
      GutschriftCreation,
      IgnoreTransaction
    },
    props: ['open_transactions', 'customers']
  };
  </script>
  